@layer components {
  .button {
    background-color: var(--navy);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border-radius: var(--radius);
    pointer-events: auto;
    transition-property: background-color, opacity;
    transition-duration: var(--duration);
    transition-timing-function: var(--easing);

    &:hover, &:focus-visible {
      background-color: var(--blue);
    }

    &[aria-hidden="true"] {
      opacity: 0;
    }

    &[aria-hidden="true"], &[aria-disabled="true"] {
      pointer-events: none;
    }
  }
}
